import React, { useState } from 'react';
import { styled } from '@compiled/react';
import { graphql, useFragment } from 'react-relay';
import EditorHelpIcon from '@atlaskit/icon/core/migration/question-circle--editor-help';
import { token } from '@atlaskit/tokens';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import type { priority_softwareReleasesVersionDetailIssueList$key } from '@atlassian/jira-relay/src/__generated__/priority_softwareReleasesVersionDetailIssueList.graphql';

type Props = {
	jiraPriorityField: priority_softwareReleasesVersionDetailIssueList$key;
};

export const Priority = ({ jiraPriorityField }: Props) => {
	const [isPriorityIconBroken, setIsPriorityIconBroken] = useState<boolean>(false);

	const { priority } = useFragment(
		graphql`
			fragment priority_softwareReleasesVersionDetailIssueList on JiraPriorityField {
				priority {
					name
					iconUrl @required(action: NONE)
				}
			}
		`,
		jiraPriorityField,
	);

	return (
		<PriorityContainer>
			{priority &&
				(isPriorityIconBroken ? (
					<EditorHelpIcon LEGACY_size="small" label={priority.name || ''} />
				) : (
					<Icon
						src={priority.iconUrl}
						alt={priority.name ?? undefined}
						title={priority.name ?? undefined}
						onError={() => {
							setIsPriorityIconBroken(true);
						}}
					/>
				))}
		</PriorityContainer>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Icon = styled.img({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${gridSize * 2}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${gridSize * 2}px`,
	marginTop: 0,
	marginRight: token('space.050'),
	marginBottom: 0,
	marginLeft: 0,
	flex: '0 0 auto',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const PriorityContainer = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${gridSize * 2}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	minWidth: `${gridSize * 2}px`,
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
});
